import { type FC, useEffect, useState } from "react";
import { remult } from "remult";
import { Roles } from "@shared/Roles";
import { useQuery } from "@tanstack/react-query";
import { useOrganization } from "../../contexts/OrganizationProvider";
import { KpiSection } from "./components/KpiSection";
import { ManagerDailyMatchesSection } from "./components/ManagerDailyMatchesSection";
import { StatisticsDailyTrendsSection } from "./components/StatisticsDailyTrendsSection";
import { StatisticsGeographicSection } from "./components/StatisticsGeographicSection";
import { StatisticsGroupInsightsSection } from "./components/StatisticsGroupInsightsSection";
import { StatisticsVolunteerInsightsSection } from "./components/StatisticsVolunteerInsightsSection";
import { EMPTY_FILTERS } from "./types";
import "./Statistics.scss";

export const Statistics: FC = () => {
  const canViewOrgStatistics = remult.isAllowed(Roles.SuperAdmin);
  const { currOrganization } = useOrganization();
  const [insightsEnabled, setInsightsEnabled] = useState(false);

  // Observe the same query key KpiSection uses with default filters (cache only).
  const { isSuccess: kpiReady } = useQuery({
    queryKey: ["statistics-kpi", currOrganization?.id, EMPTY_FILTERS],
    queryFn: async () => null,
    enabled: false,
  });

  useEffect(() => {
    if (kpiReady) setInsightsEnabled(true);
  }, [kpiReady]);

  return (
    <div className="statistics-container">
      <div className="statistics-header">
        <h1>סטטיסטיקות</h1>
      </div>

      <div className="statistics-section">
        <ManagerDailyMatchesSection />
      </div>

      {canViewOrgStatistics && (
        <>
          <div className="statistics-section">
            <StatisticsDailyTrendsSection filters={EMPTY_FILTERS} />
          </div>
          <div className="statistics-section">
            <KpiSection />
          </div>
          <div className="statistics-section">
            <StatisticsVolunteerInsightsSection
              filters={EMPTY_FILTERS}
              enabled={insightsEnabled}
            />
          </div>
          <div className="statistics-section">
            <StatisticsGroupInsightsSection
              filters={EMPTY_FILTERS}
              enabled={insightsEnabled}
            />
          </div>
          <div className="statistics-section">
            <StatisticsGeographicSection
              filters={EMPTY_FILTERS}
              enabled={insightsEnabled}
            />
          </div>
        </>
      )}
    </div>
  );
};
